'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (theme, props) {
    var wrap = {},
        palette = theme.palette;


    if (!props.multiline) {
        wrap = {
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal'
        };
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            position: 'relative',
            display: theme.display
        },
        content: Object.assign({
            display: 'block',
            position: 'absolute',
            top: '10px',
            background: theme.background,
            boxSizing: 'border-box',
            border: theme.border,
            boxShadow: theme.boxShadow,
            borderRadius: theme.borderRadius,
            zIndex: theme.zIndex,
            minWidth: theme.minWidth,
            width: theme.width,
            maxWidth: theme.maxWidth,
            left: 0,
            whiteSpace: 'normal',
            color: theme.color,
            padding: theme.padding,
            textAlign: theme.textAlign
        }, wrap, {

            '&:after': {
                position: 'absolute',
                content: '""',
                display: 'block',
                width: 0,
                height: 0,
                left: '10px',
                top: '-10px',
                zIndex: palette.zOverlay,
                border: '5px solid transparent',
                borderBottomColor: palette.elPrimary
            }
        }),
        close: {
            position: 'absolute',
            top: palette.gutter + 'px',
            right: palette.gutter + 'px',
            display: 'inline-block',
            cursor: 'pointer'
        },
        closeIcon: {
            height: palette.gutter * 3 + 'px',
            width: palette.gutter * 3 + 'px',
            backgroundImage: 'url("' + theme.closeIcon + '")',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
        },
        animation: {
            transition: 'opacity ' + palette.transitionDuration + ' ' + palette.transitionFunction,

            '&-enter': {
                opacity: 0
            },

            '&-enter-active': {
                opacity: 1
            },
            '&-exit': {
                opacity: 1
            },
            '&-exit-active': {
                opacity: 0
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        close: (0, _aphroditeJss.css)(styleList.close),
        closeIcon: (0, _aphroditeJss.css)(styleList.closeIcon),
        content: (0, _aphroditeJss.css)(styleList.content),
        animation: (0, _aphroditeJss.css)(styleList.animation)
    };
};

var _aphroditeJss = require('aphrodite-jss');